<template>
	<div>
		<title-header class="tw-mb-4">
			<v-layout row wrap justify-end align-center>
				<div class="wrapper-btns">
					<p-button :disabled="this.indexTab === 1 || this.dataSelected.length === 0" type="primary" @click="assingTemplates">Asignar Plantillas</p-button>
				</div>
			</v-layout>
		</title-header>
		<div class="tw-flex tw-w-full tw-justify-end">
			<selector-assign-template
				:index-tab="indexTab"
				@typeAssign="handlerTypeAssign"
			></selector-assign-template>
		</div>
		<app-table
			class="mt-3 no-main-list"
			:columns="columns"
			:filter-columns="false"
			:rows="templates"
			:items-quantity="templates.length"
			:items-total-quantity="totalItems"
			:current-page="currentPage"
			:last-page="lastPage"
			:check-all="checkAll"
			selectable
			@on-page="changePage"
			@on-search-event="onSearchEvent"
			@changeSort="changeSort"
			@changeColor="changeColor"
			@row-is-selected="rowIsSelected"
			@on-selected-all="selectedAll"
		>
			<template slot="rows" slot-scope="props">
				<td style="width: 50%; text-align: left; padding-left: 20px;" v-show="showRow(columns, 1)">{{ props.row.code }}</td>
				<td style="width: 50%;" v-show="showRow(columns, 2)">{{ props.row.name }}</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import PButton from '@/modules/shared/components/ui/p-button';
import titleHeader from '@/components/diagnosis/title-header';
import selectorAssignTemplate from '@/components/configuration/report-template/selector-assign-template';

export default {
	name: 'report-template',
	components: {
		PButton,
		titleHeader,
		selectorAssignTemplate,
	},
	data() {
		return {
			templates: [],
			indexTab: 0,
			columns: [
				{
					id: 1,
					name: 'Código',
					value: 'code',
					visible: true,
					checked: true,
					sortCheck: true,
					fieldName: 'code',
					color: 'gray',
				},
				{
					id: 2,
					name: 'Nombre',
					value: 'name',
					visible: true,
					checked: true,
					sortCheck: true,
					fieldName: 'name',
					color: 'gray',
				},
			],
			params: {
				limit: 10,
				page: 1,
			},
			currentPage: 1,
			totalItems: 0,
			lastPage: 1,
			checkAll: false,
			dataSelected: [],
		};
	},
	created() {
		this.loadTemplates();
	},
	methods: {
		async loadTemplates() {
			const params = {
				...this.params,
			};
			try {
				const { data: response, headers } = await this.$httpPraktiko.get('templates/company', { params });
				this.templates = response;
				this.lastPage = Number(headers['x-last-page']);
				this.totalItems = Number(headers['x-quantity']);
			} catch (error) {
				this.showGenericError();
			}
		},
		async loadTemplateAssign() {
			const params = {
				...this.params,
			};
			try {
				const { data: response, headers } = await this.$httpPraktiko.get('/templates/assign-company', { params });
				this.templates = response;
				this.lastPage = Number(headers['x-last-page']);
				this.totalItems = Number(headers['x-quantity']);
			} catch (error) {
				this.showGenericError();
			}
		},
		changePage(page) {
			this.params.page = page;
			this.currentPage = page;
			if (this.indexTab === 0) {
				this.loadTemplates();
			} else {
				this.loadTemplateAssign();
			}
		},
		onSearchEvent(search) {
			this.params.search = search.trim() || null;
			this.changePage(1);
		},
		changeColor(fieldName) {
			this.columns.forEach((c, index) => {
				if (c.fieldName !== fieldName && c.color) {
					this.$set(this.columns, index, { ...c, color: 'gray' });
				}
			});
		},
		changeSort({ fieldName, sortDirection }) {
			this.params.sortField = fieldName;
			this.params.sortDirection = sortDirection;
			this.loadTemplates();
		},
		rowIsSelected(value) {
			if (value.isSelected) {
				this.dataSelected.push(value);
			} else {
				const index = this.dataSelected.findIndex(d => d.id === value.id);
				if (index > -1) {
					this.dataSelected.splice(index, 1);
				}
			}
			this.checkAll = this.templates.every(e => e.isSelected);
		},
		selectedAll(value) {
			this.templates = this.templates.map((r) => {
				const newRow = { ...r };
				newRow.isSelected = value;
				return newRow;
			});
			this.checkAll = value;
			this.dataSelected = value ? [...this.templates] : [];
		},
		async assingTemplates() {
			const dataReestructured = this.dataSelected.map(({ code, name, template, id }) =>
				({ code, name, template, templateId: id }));
			const body = {
				templates: dataReestructured,
			};
			try {
				await this.$httpPraktiko.post('templates/company', body);
				this.showNotification('Plantillas Asignadas Correctamente');
				this.loadTemplates();
			} catch (error) {
				this.showGenericError();
			} finally {
				this.dataSelected = [];
			}
		},
		handlerTypeAssign(index) {
			this.indexTab = index;
			if (this.indexTab === 0) {
				this.loadTemplates();
			} else {
				this.loadTemplateAssign();
			}
		},
	},
	watch: {
		indexTab: {
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dataSelected = [];
				}
			},
		},
	},
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/pages/configuration/report-template.vue